import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../customCheckbox';

const NotificationHeader = ({ showNotificationPopup, onSelectorChange, companies, selectedCompany }) => {
    return (
        <div className="notif-header">
            <h1>Manage users notifications</h1>
            <h3>
                <Checkbox checked={false} color="blue" /> - email notifications &nbsp;&nbsp;
                <Checkbox checked={false} color="green" /> - push notifications
            </h3>
            <button type="button" onClick={showNotificationPopup} className="open-custom-notif">
                Send custom notification
            </button>
            <div className="indices-market-selector-holder">
                <div className="indices-market-selector-label">Select company</div>
                <select className="market-selector" onChange={onSelectorChange} value={selectedCompany || ''}>
                    <option value="non-users">ALL NON USERS</option>
                    {companies && companies.length
                        ? companies.map(item => (
                              <option key={`compsel_${item.id}`} value={item.id}>
                                  {item.name}
                              </option>
                          ))
                        : null}
                </select>
            </div>
        </div>
    );
};

NotificationHeader.propTypes = {
    showNotificationPopup: PropTypes.func.isRequired,
    onSelectorChange: PropTypes.func.isRequired,
    companies: PropTypes.arrayOf(PropTypes.shape({})),
    selectedCompany: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

NotificationHeader.defaultProps = {
    selectedCompany: null,
};

export default React.memo(NotificationHeader);



// WEBPACK FOOTER //
// ./source/components/manageNotifications/notificationsHeader.js